export enum QueryParamKey {
    /** Team ID selected for the application */
    TEAM_ID = 'teamid',
    /** Period selected for the applications */
    PERIOD = 'period',
    /** Timestamp for the video player in format HH:MM:SS:FF */
    TIMESTAMP = 'timestamp',
    /** Event ID selected for the application */
    EVENT_ID = 'eventid'
}

export type TQueryParams = Partial<Record<QueryParamKey, string>>;
